export default __webpack_public_path__ + "dist/media/Search.3938687b.svg";